import React, { useState } from 'react';

/** Hoisted from StorageConfiguratorApp (CONF-140 Phase 0b). Same props, same markup. */
const SaveQuoteDialog = ({ isOpen, onClose, onSave }) => {
  const [localDescription, setLocalDescription] = useState('');

  const handleSave = () => {
    // Replaces the original inline dialog's `alert('Please enter a quote
    // description')` on empty input. Unreachable in both versions — the Save
    // button is `disabled={!localDescription.trim()}` and the Enter handler
    // below has its own `.trim()` guard — so this is a silent no-op, not a
    // converted alert; the phase's "13 alerts converted" count is 13 of 14 for
    // that reason.
    if (!localDescription.trim()) return;
    onSave(localDescription);
    setLocalDescription('');
    onClose();
  };

  const handleClose = () => {
    setLocalDescription('');
    onClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && localDescription.trim()) handleSave();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-800 p-6 rounded-lg w-96">
        <h2 className="text-xl font-bold mb-4 text-white">Save Configuration</h2>
        <input
          type="text"
          value={localDescription}
          placeholder="Enter quote description"
          className="w-full p-2 mb-4 border rounded text-black bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
          onChange={(e) => setLocalDescription(e.target.value)}
          onKeyPress={handleKeyPress}
          autoFocus
        />
        <div className="flex-row-tight">
          <button
            onClick={handleClose}
            className="px-4 py-2 border border-gray-300 rounded text-white hover:bg-gray-700"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
            disabled={!localDescription.trim()}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveQuoteDialog;
